module.exports = __webpack_public_path__ + "img/magento-modules-customization_small@2x.859ece57.webp";